<template>
  <div class="order-applicant-wrap">
    <div class="title">
      <img :src="order.national_flag_img">
      <router-link target="_blank" :to="goProduct(order)">{{order.product_name}}</router-link>
      <div class="evaluation-box" @click="goToEvaluate" v-if="order.need_review || (!order.need_review && order.order_review && order.order_review.order_review_id)">
        <span v-if="order.need_review">服务评价</span>
        <span v-if="!order.need_review && order.order_review && order.order_review.order_review_id">查看评价</span>
      </div>
      <div class="complete-material" @click="completeMaterial" v-if="showWaitCompleteMaterial">
        <img src="../../assets/imgs/order-detail/document.png" class="icon">
        <span class="text-box">待完善资料清单</span>
      </div>
    </div>
    <div class="applicant-info" v-if="order.applicant">
      <div :class="{'items': true}" v-for="(ap, index) in collapsed ? order.applicant : order.applicant.slice(0, 3)" :key="index">
        <div class="name" :class="{'is-fliggy': order.ota_info}">{{ap.applicant_name}}<span v-if="order.ota_info">({{`${ap.surname_pinyin} ${ap.given_name_pinyin}`}})</span></div>
        <div class="job" v-text="ap.identity"></div>
        <div
          class="status"
          :class="{'danger': isDangerStatus(ap.applicant_status), 'cursor-pointer': ap.applicant_status === 6}"
          @click="handlerClickApplicantStatus(ap)"
        >
          <span>{{apStatus[ap.applicant_status]}}</span>
          <img v-if="ap.applicant_status === 6" class="refuse-img" slot="reference" src="../../assets/imgs/order/reject_warn.png" />
        </div>


        <div class="btn" v-if="!admin">
          <div v-if="isRejectProduct(ap)">
            <router-link class="el-button el-button--primary" :to="getRejectProductUrlObj(ap)" v-if="getFileStatusByApplicant(ap) === 0">申请赔付</router-link>
            <router-link class="el-button el-button--primary" :to="getRejectProductUrlObj(ap, true)" v-else-if="getFileStatusByApplicant(ap) === 2">查看原因</router-link>
            <span v-else class="reject-status-text">{{ showRejectProductStatusText(ap) }}</span>
          </div>
          <router-link v-else class="el-button" :class="buttonClassObject(ap.applicant_status)" :to="getUrlObj(ap)">{{btnName(ap)}}</router-link>
        </div>
      </div>

      <expand class="info-expand" :default-length="3" :max-length="order.applicant.length"  @expanded="x => collapsed = x" />
      <div class="fliggy-info-box" v-if="order.ota_info">
        <fliggy-order-info-bar :ota-info="order.ota_info"></fliggy-order-info-bar>
      </div>
    </div>

    <order-reject-visa-detail-dialog :show.sync="rejectVisaDialog.show" :user_order_id="order.user_order_id" :order_applicant_id="rejectVisaDialog.order_applicant_id"></order-reject-visa-detail-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import status from '../../libs/status.js';
import expand from '../../components/common/expand';
import OrderRejectVisaDetailDialog from './modals/order-reject-visa-detail-dialog';
import sensorService from '../../services/sensor-service';
import FliggyOrderInfoBar from '@/components/ota/fliggy-order-info-bar.vue';

export default {
  name: 'orderApplicantInfos',
  components: {
    expand,
    OrderRejectVisaDetailDialog,
    FliggyOrderInfoBar,
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    admin: {
      type: Number,
    },

    // 是否显示待完善资料清单按钮
    showWaitCompleteMaterial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rejectProductStatus: status.rejectProductStatus,
      apStatus: status.apStatus,
      rejectFileStatus: status.rejectFileStatus,
      collapsed: false,
      malaStatus: 0,
      rejectVisaDialog: { // 拒签弹窗
        show: false,
        order_applicant_id: 0,
      },
    };
  },
  watch: {
    order() {
      if (this.refresh) {
        this.refresh = false;
        Message.success({
          message: '申请人状态更新成功',
        });
      }
    },
  },
  methods: {
    // 判断指定申请人是否显示申请赔付按钮
    isRejectProduct(ap) { 
      // 0: '已取消',
      // 1: '等待预审',
      // 2: '资料不完善',
      // 3: '等待送签',
      // 4: '使馆审核中',
      // 5: '出签成功',
      // 6: '拒签',
      // 7: '退款中',
      // 8: '退款成功',
      // 9: '等待预约',
      // 10: '待确认',
      // 11: '等待接收资料',
      // 12: '等待培训',
      // 13: '待前往使馆',
      // 14: '拒签(待提交证明)',
      // 15: '拒签(等待审核)',
      // 16: '拒签(审核不通过)',
      // 17: '资料不完善（待退款）',
      // 18: '预约成功',
      return [6, 14, 15, 16].includes(ap.applicant_status) && this.order.reject_product_set && this.order.reject_product_set.reject_product_id;
    },
    // 获取指定申请人拒签商品信息
    getApplicantRejectProduct(ap) {
      if (!this.order.reject_product_set) return;
      // 根据当前的id查询当前申请人的拒签商品信息
      const applicantRejectProduct = this.order.reject_product_set.applicant_set.find(item => item.applicant_id === ap.order_applicant_id);
      if (!applicantRejectProduct) return;
      return applicantRejectProduct;
    },
    // 是否显示赔付按钮以及查看原因按钮，只有申请人状态为保障生效中才有效
    getFileStatusByApplicant(ap) {
      const applicantRejectProduct = this.getApplicantRejectProduct(ap);
      if (!applicantRejectProduct) return;
      // 0保障生效中 1保障成功 2保障结束 3保障已赔付
      if (applicantRejectProduct.status !== 0) return;
      // file_status: 0待上传 1等待审核 2审核不通过 3审核通过 4超时未提交
      return applicantRejectProduct.file_status;
    },
    // 显示对应的文字
    showRejectProductStatusText(ap) {
      const applicantRejectProduct = this.getApplicantRejectProduct(ap);
      if (!applicantRejectProduct) return;
      // 0保障生效中 1保障成功 2保障结束 3保障已赔付
      if (applicantRejectProduct.status !== 0) {
        return this.rejectProductStatus[applicantRejectProduct.status];
      } 
      return `拒签材料${this.rejectFileStatus[applicantRejectProduct.file_status]}`;
    },
       
    // 获取按钮名称
    btnName(ap) {
      let name = '';
      if (ap.applicant_status === 2) {
        name = '修改资料';
      } else {
        name = '查看资料';
      }
      return name;
    },

    // 获取按钮跳转路由
    getUrlObj(ap) {
      const obj = {};
      obj.name = 'reupload';
      obj.params = { oid: this.order.user_order_id, aid: ap.order_applicant_id, back: false };
      return obj;
    },

    // 获取申请申请赔付路由跳转
    getRejectProductUrlObj(ap, isReUpload) {
      const obj = {};
      obj.name = 'rejectProductApplicant';
      obj.params = { oid: this.order.user_order_id, aid: ap.order_applicant_id, isReUpload };
      return obj;
    },
    /**
     * 是否为需要显示红色的状态
     * @param {Number} status 申请人状态
     * @return {Boolean} 是否需要显示红色
     */
    isDangerStatus(status) {
      if (!status) return false;

      const dangerStatus = [2, 5, 6, 8, 13, 17, 18];

      return dangerStatus.indexOf(status) > -1;
    },


    /**
     * 按钮的样式计算
     * @param {Number} applicant_status 申请人状态
     * @return {Object} class对象
     */
    buttonClassObject(applicant_status) {
      const verifyNotPassStatus = 2;
      return {
        blue: applicant_status !== verifyNotPassStatus,
        'el-button--default': applicant_status !== verifyNotPassStatus,
        white: applicant_status === verifyNotPassStatus,
        'el-button--primary': applicant_status === verifyNotPassStatus,
      };
    },

    // 去到订单评价界面
    goToEvaluate() {
      this.$router.push({
        name: 'orderEvaluation',
        params: {
          oid: this.order.user_order_id,
        },
      });
    },

    // 处理点击申请人状态
    handlerClickApplicantStatus(applicant) {
      if (+applicant.applicant_status === 6) {
        // 拒签
        this.rejectVisaDialog.order_applicant_id = applicant.order_applicant_id;
        this.rejectVisaDialog.show = true;
      }
    },

    completeMaterial() {
      this.$emit('completeMaterial');
    },
    // 获取路由跳转地址
    goProduct(order) {
      // 商详神策埋点page_from字段
      const pageFrom = sensorService.getPageFrom('订单页');
      return { name: 'product', params: { visa_product_id: order.visa_product_id }, query: { from: 'order_detail', ...pageFrom } };
    },
  },
};
</script>

<style>
.refuse-detail.el-popover {
	width: auto !important;
	background-color: #ffffff;
	box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.05);
	border: solid 1px #f0f0f0;
	font-size: 14px;
	line-height: 24px;
	color: #ff5a60;
  padding: 10px 15px;
}
</style>

<style lang="less" scoped>
@import  '../../assets/less/variable';
.order-applicant-wrap {
  margin-top: 15px;
  background-color: #fff;
  .title {
    height: 65px;
    border-bottom: 1px dashed @border;
    font-size: 16px;
    color: @text-dark;
    font-weight: 700;
    padding-left: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    a:link, a:visited, a:hover, a:active {
      color: @text-dark;
    }
    a {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 20px;
    }
    img {
      background-color: #831c1c;
      border-radius: 4px;
      border: solid 1px #f0f0f0;
      width: 36px;
      margin-right: 15px;
    }
    a:hover  {
      color: #5e9be1;
    }
    .evaluation-box{
      font-size: 14px;
      color: #5e9be1;
      margin-right: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      &::before{
        content: '';
        background-image: url('../../assets/imgs/order/evaluate.png');
        width: 16px;
        height: 15px;
        margin-right: 6px;
        transform: translateY(1px);
      }
    }
    .complete-material{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-right: 40px;
      cursor: pointer;
      .icon{
        background-color: transparent;
        width: 16px;
        height: 15px;
        margin-right: 6px;
      }
      .text-box{
        font-size: 14px;
        color: #5e9be1;
      }
    }
  }
  .applicant-info {
    min-height:60px;
    background-color: #fff;
    padding-top: 2px;
    .items+.items {
      border-top: 1px solid #f0f0f0;
    }
    .items {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 18px;
      position: relative;
      padding: 0 40px;
      &.applicant-info-stess {
        background-color: #ffffde;
      }
      .btn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        .el-button {
          width: 96px;
          height: 34px;
          line-height: 33px;
          padding: 0;
          &.el-button-mala {
            margin-left: 20px;
            width: 100px;
            background-color: #5e9be1;
            border: solid 1px #5e9be1;
            font-size: 14px;
            color: #ffffff;
          }
        }
        .reject-status-text {
          font-size: 16px;
          color: #91999F;
        }
      }
      .status {
        width: 160px;
        font-size: 14px;
        color: #333;
        flex-grow: 0;
        flex-shrink: 0;
        margin-right: 40px;
        // position: absolute;
        // top: 50%;
        // transform: translateY(-50%);
        // left: 440px;
        display: flex;
        align-items: center;

        // 图片是用最后一个 span 标签包裹，下面样式是为了让图标、文字垂直居中对齐
        span:last-of-type{
          // font-size: 0;
          display: inline-block;
        }

        &.danger {
          color: #f66878;
        }
        &.cursor-pointer{
          cursor: pointer;
        }
        .refuse-visa {
          font-size: 0px;
        }
        .refuse-img {
          height: 16px;
          width: 16px;
          margin-left: 5px;
          cursor: pointer;
        }
      }
      .name {
        min-width: 80px;
        max-width: 80px;
        margin-right: 40px;
        font-size: 16px;
        color: #333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.is-fliggy{
          min-width: 100px;
          max-width: 400px;
          margin-right: 20px;
        }
      }
      .job {
        width: 40%;
        color: #777;
        font-size: 14px;
      }
    }
    .info-expand {
      margin: 0 40px;
    }
  }
  .bottom {
    height: 40px;
    background-color: #fbfbfb;
    display: flex;
    align-items: center;
    padding: 0 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #777;
    display: flex;
    align-items: center;
    .ota-logo {
      width: 22px;
    }
    .ota-name {
      margin-left: 10px;
      margin-right: 8px;
    }
    .store-name {
      margin-left: 8px;
    }
    .ota-order-num {
      margin-left: 10px;
      color: #777;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .blue {
    border: 1px solid @main;
    color: @main;
  }
  .fliggy-info-box{
    background-color: #fbfbfb;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/order-detail/order-applicant-infos.vue